import React from 'react';

import getResizedImageUrl from '@components/havenly/lib/getResizedImageUrl';
import * as clickTypes from '@constants/tracking/clickTypes';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import styles from './ContentStyles.module.scss';

export const CONTENT_BY_MODEL_NAME = {
  vendor_variants: vendorVariantContent,
};

export function vendorVariantContent(props) {
  const {
    assetId, annotationModel, annotationModelId, vendorVariant,
  } = props;

  const imageUrls = {
    '1x': getResizedImageUrl({
      url: vendorVariant.image.uri,
      width: 45,
      height: 45,
      quality: 100,
    }),
    '2x': getResizedImageUrl({
      url: vendorVariant.image.uri,
      width: 90,
      height: 90,
      quality: 50,
    }),
  };

  return (
    <div className={ styles.Content }>
      <a
        className={ styles.Image }
        href={ `/products/details/${annotationModelId}` }
        onClick={
          (e) => {
            e.stopPropagation();
            handleTrackAnnotationContentClicked(
              assetId, annotationModel, annotationModelId, clickTypes.ANNOTATION_LINK_IMG,
            );
          }
        }
        rel="noopener nofollow noreferrer"
        target="_blank"
      >
        <img
          alt=""
          src={ imageUrls['1x'] }
          srcSet={ `${imageUrls['2x']} 2x` }
        />
      </a>
      <div>
        <a
          className={ styles.Title }
          href={ `/products/details/${annotationModelId}` }
          onClick={
             (e) => {
               e.stopPropagation();
               handleTrackAnnotationContentClicked(
                 assetId, annotationModel, annotationModelId, clickTypes.ANNOTATION_LINK_TITLE,
               );
             }
          }
          rel="noopener nofollow noreferrer"
          target="_blank"
        >
          { vendorVariant.title }
        </a>
        <div className={ styles.Text }>
          ${ vendorVariant.prices[0].price } | { vendorVariant.vendor.name }
        </div>
      </div>
    </div>
  );
}

function handleTrackAnnotationContentClicked(
  assetId, annotationModelName, annotationModelId, clickType,
) {
  analyticsTrack(
    'explore_image_annotation_clicked',
    {
      assetId,
      annotationModelName,
      annotationModelId,
      clickType,
    },
  );
}
